// extracted by mini-css-extract-plugin
export default {"container":"paymentSection_container__G6ejT"};